import { Action } from '@ngrx/store';
import { RideGroup } from 'src/app/models/ride-group';
import { RideGroupRiderStatus } from 'src/app/models/ride-group-rider-status';

export const OfflineRideGroupActions = {
    addRideGroup: '[offline ride group] add ride group',
    clearAllRideGroups: '[offline ride group] clear all ride groups',
    removeRideGroup: '[offline ride group] remove ride group',
    setRideGroups: '[offline ride group] set ride groups',
};

export const RideGroupActions = {
    addRideGroup: '[ride group] add ride group',
    clearAllRideGroups: '[ride group] clear all ride groups',
    removeRideGroup: '[ride group] remove ride group',
    setActiveRideGroup: '[ride group] set active ride group',
    setActiveRideGroupLeader: '[ride group] set active ride group leader',
    setActiveRideGroupRider: '[ride group] set active ride group rider',
    setRideGroups: '[ride group] set ride groups',
    startFollowingLeader: '[ride group] start following leader',
    startFollowingRideGroup: '[ride group] start following ride group',
    stopFollowing: '[ride group] stop following',
    stopFollowingLeader: '[ride group] stop following leader',
    stopFollowingRideGroup: '[ride group] stop following ride group',
    updateRideGroupLeader: '[ride group] update ride leader',
};

export const RideGroupRiderActions = {
    setRideGroupRiders: '[ride group riders] set ride group riders',
};

export class AddOfflineRideGroup implements Action {
    type = OfflineRideGroupActions.addRideGroup;
    constructor(public rideGroup: RideGroup) {}
}

export class ClearAllOfflineRideGroups implements Action {
    type = OfflineRideGroupActions.clearAllRideGroups;
}

export class RemoveOfflineRideGroup implements Action {
    type = OfflineRideGroupActions.removeRideGroup;
    constructor(public rideGroup: RideGroup) {}
}

export class SetOfflineRideGroups implements Action {
    type = OfflineRideGroupActions.setRideGroups;
    constructor(public rideGroups: RideGroup[]) {}
}

export class AddRideGroup implements Action {
    type = RideGroupActions.addRideGroup;
    constructor(public rideGroup: RideGroup) {}
}

export class ClearAllRideGroups implements Action {
    type = RideGroupActions.clearAllRideGroups;
}

export class RemoveRideGroup implements Action {
    type = RideGroupActions.removeRideGroup;
    constructor(public rideGroup: RideGroup) {}
}

export class SetActiveRideGroup implements Action {
    type = RideGroupActions.setActiveRideGroup;
    constructor(public rideGroup?: RideGroup) {}
}

export class StartFollowingRideGroup implements Action {
    type = RideGroupActions.startFollowingRideGroup;
}

export class StopFollowingRideGroup implements Action {
    type = RideGroupActions.stopFollowingRideGroup;
}

export class StopFollowingRideGroupAndLeader implements Action {
    type = RideGroupActions.stopFollowing;
}

export class StartFollowingLeader implements Action {
    type = RideGroupActions.startFollowingLeader;
}

export class StopFollowingLeader implements Action {
    type = RideGroupActions.stopFollowingLeader;
}

export class SetRideGroups implements Action {
    type = RideGroupActions.setRideGroups;
    constructor(public rideGroups: RideGroup[]) {}
}

export class SetActiveRideGroupRider implements Action {
    type = RideGroupActions.setActiveRideGroupRider;
    constructor(public rider?: RideGroupRiderStatus) {}
}

export class SetActiveRideGroupLeader implements Action {
    type = RideGroupActions.setActiveRideGroupLeader;
    constructor(public leader: RideGroupRiderStatus | undefined) {}
}

export class UpdateRideGroupLeader implements Action {
    type = RideGroupActions.updateRideGroupLeader;
    constructor(public leader: RideGroupRiderStatus) {}
}

export class SetRideGroupRiders implements Action {
    type = RideGroupRiderActions.setRideGroupRiders;
    constructor(public riders: RideGroupRiderStatus[] | undefined) {}
}
